export default {
  HOME: '/',
  SIGN_IN: '/sign-in',
  SUBSCRIBE: '/subscribe',
  SUBSCRIBE_PROMOTION: '/subscribe/promotion',
  SIGN_UP: '/subscribe/sign-up',
  SIGN_UP_SUCCESS: '/subscribe/sign-up/success',
  SIGN_UP_CONFIRM: '/subscribe/sign-up/confirm',
  PAYMENT_RESULT: '/subscribe/payment-status',
  FORGOT_PASSWORD: '/reset-password',
  FORGOT_PASSWORD_CONFIRM: '/reset-password/confirm',
  SIGN_UP_CONFIRM_REDIRECT: '/sign-up/confirm',
  ACCOUNT: '/account',
  ACCOUNT_DEVICES: '/account/devices',
  ACCOUNT_SUBSCRIPTION: '/account/subscription',
  CHANGE_PAYMENT_CONFIRM: '/account/payment/confirm',
  CHANGE_PAYMENT_RESULT: '/account/payment/status',
};
